import { SegmentationIds, SEGMENTS_RAW_FILTER_MAP } from 'constants/segmentation';

const SubtitleMap = {
  [SegmentationIds.CatDigestion]: 'Ideal für Katzen mit Verdauungsproblemen',
  [SegmentationIds.CatOverweight]: 'Ideal für Katzen mit Übergewicht',
  [SegmentationIds.Kitten]: 'Ideal für Kitten 2-12 Monate',
  [SegmentationIds.CatSenior]: 'Ideal für Senioren',
};

/**
 * Function to get getPersonalizedSubtitle for old collection product
 */
const getPersonalizedSubtitle = ({
  tags,
  segmentation,
}: {
  tags: Array<string>;
  segmentation: SegmentationIds;
}): string | undefined => {
  // First try exact match
  const exactEntry = Object.entries(SEGMENTS_RAW_FILTER_MAP).find(
    ([, value]) => value === segmentation
  );

  // If no exact match, try array match
  const arrayEntry = !exactEntry
    ? Object.entries(SEGMENTS_RAW_FILTER_MAP).find(
        ([, value]) => Array.isArray(value) && value.includes(segmentation)
      )
    : null;

  const entry = exactEntry || arrayEntry;

  if (!entry) return undefined;

  const segmentTag = tags.find((tag) => tag === entry[0]);

  if (!segmentTag) return undefined;

  return SubtitleMap[segmentation] as string;
};

export default getPersonalizedSubtitle;
